import { configureStore } from '@reduxjs/toolkit';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import settingsPanelSlice from '../features/common/settingsPanelSlice';
import clientSlice from '../features/kunden/clientSlice';
import projectSlice from '../features/projekte/projectSlice';
import settingsSlice from '../features/settings/settingsSlice';
import plantafelSlice from '../features/plantafel/plantafelSlice';
import { fehlerErfassen } from '../utils/nutzung';

// Jede rote Meldung, die der Nutzer sieht, landet auch im Fehlerprotokoll
const fehlermeldungenErfassen = () => (next) => (action) => {
  if (action.type === 'header/showNotification' && action.payload?.status === 0 && action.payload?.message) {
    fehlerErfassen('meldung', String(action.payload.message));
  }
  return next(action);
};

const store = configureStore({
  reducer: {
    header: headerSlice,
    rightDrawer: rightDrawerSlice,
    settingsPanel: settingsPanelSlice,
    modal: modalSlice,
    clients: clientSlice,
    projects: projectSlice,
    settings: settingsSlice,
    plantafel: plantafelSlice,
  },
  middleware: (getDefault) => getDefault().concat(fehlermeldungenErfassen),
});

// ✅ Expose Redux store globally for debugging
if (typeof window !== 'undefined') {
  window.store = store;
}

export default store;
